/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `Information about Open Educational Resources OER`
};

const fr_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `Informations sur les ressources éducatives libres (REL)`
};

const de_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `Informationen zu Open Educational Resources OER`
};

const es_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `Información sobre Recursos Educativos Abiertos REA`
};

const it_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `Informazioni sulle risorse educative aperte (OER)`
};

const ar_oer_information_page_description29 = /** @type {(inputs: {}) => string} */ () => {
	return `معلومات حول الموارد التعليمية المفتوحة OER`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_page_description29 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_page_description29(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_page_description29", locale)
	if (locale === "en") return en_oer_information_page_description29(inputs)
	if (locale === "fr") return fr_oer_information_page_description29(inputs)
	if (locale === "de") return de_oer_information_page_description29(inputs)
	if (locale === "es") return es_oer_information_page_description29(inputs)
	if (locale === "it") return it_oer_information_page_description29(inputs)
	return ar_oer_information_page_description29(inputs)
};
export { oer_information_page_description29 as "OER_INFORMATION_PAGE_DESCRIPTION" }